import { combineReducers } from 'redux'

// Export Actions
export * as overview from './tasks/tasks-overview'
export * as registrationParticipants from './tasks/tasks-registration-participants'
export * as registrationAwardLeaders from './tasks/tasks-registration-award-leaders'
export * as registrationAwardUnits from './tasks/tasks-registration-award-units'
export * as activityApproval from './tasks/tasks-activity-approval'
export * as sectionSignoff from './tasks/tasks-section-signoff'
export * as aj from './tasks/tasks-aj'
export * as awardSignoff from './tasks/tasks-award-signoff'
export * as unassignedParticipants from './tasks/tasks-unassigned-participants'
export * as rp from './tasks/tasks-rp'
export * as assessors from './tasks/tasks-assessors'
export * as emailRevision from './tasks/tasks-email-revision'
export * as wwcUpdate from './tasks/tasks-wwc-update'
export * as invitedParticipants from './tasks/tasks-invited-participants'

// Reducers
/* eslint-disable */
import overview from './tasks/tasks-overview'
import registrationParticipants from './tasks/tasks-registration-participants'
import registrationAwardLeaders from './tasks/tasks-registration-award-leaders'
import registrationAwardUnits from './tasks/tasks-registration-award-units'
import activityApproval from './tasks/tasks-activity-approval'
import sectionSignoff from './tasks/tasks-section-signoff'
import aj from './tasks/tasks-aj'
import awardSignoff from './tasks/tasks-award-signoff'
import unassignedParticipants from './tasks/tasks-unassigned-participants'
import rp from './tasks/tasks-rp'
import assessors from './tasks/tasks-assessors'
import emailRevision from './tasks/tasks-email-revision'
import wwcUpdate from './tasks/tasks-wwc-update'
import invitedParticipants from './tasks/tasks-invited-participants'
/* eslint-enable */

export default combineReducers({
  activityApproval,
  aj,
  assessors,
  awardSignoff,
  overview,
  registrationAwardLeaders,
  registrationAwardUnits,
  registrationParticipants,
  rp,
  sectionSignoff,
  unassignedParticipants,
  emailRevision,
  wwcUpdate,
  invitedParticipants
})
